import type { FormData } from 'src/types/appState';

export const isWritePageCompleted = (formData?: FormData) =>
  formData?.isGuided
    ? (formData?.qualifications ?? []).length !== 0 &&
      (formData?.responsibilities ?? []).length !== 0 &&
      Boolean(formData?.jobSummary)
    : Boolean(formData?.jobDescription) && Boolean(formData?.jobSummary);

export const isWritePageStarted = (formData?: FormData) =>
  (formData?.qualifications ?? []).length !== 0 ||
  (formData?.responsibilities ?? []).length !== 0 ||
  Boolean(formData?.jobDescription) ||
  Boolean(formData?.jobSummary);
